import { GENERATE_API_KEY, DEACTIVATE_API_KEY } from "./Mutations";
import { GET_API_KEYS } from "./Queries";

export class ApiAccessClient {
  constructor(client) {
    this.client = client;
  }

  async getApiKeys() {
    const res = await this.client.query({
      query: GET_API_KEYS,
      fetchPolicy: "network-only",
    });
    return res.data.apiKeys;
  }

  async generateApiKey({ name, scopes }) {
    const res = await this.client.mutate({
      mutation: GENERATE_API_KEY,
      variables: { name, scopes },
    });
    return res.data.generateApiKey;
  }

  async deactivateApiKey({ id }) {
    const res = await this.client.mutate({
      mutation: DEACTIVATE_API_KEY,
      variables: { apiKeyId: id },
    });
    return res.data.deactivateApiKey;
  }
}
